// Журнал доступа к данным учеников (152-ФЗ, backend data_access_log).
// Чтение — только администрация своей школы (GET /audit/access);
// экспорт, сформированный в браузере, клиент сам сообщает серверу.
import { api } from './client.ts'

export type AccessAction = 'view' | 'create' | 'update' | 'delete' | 'export' | 'ai'

export interface AccessLogEntry {
  id: number
  occurredAt: number
  actorKind: 'user' | 'service'
  actorId: string
  actorRole?: string | null
  ownerId?: string | null
  action: AccessAction
  entityType: string
  entityId?: string | null
  studentIds: string[]
  itemCount: number
  source: string
  ip?: string | null
  userAgent?: string | null
}

export interface AccessLogPage {
  records: AccessLogEntry[]
  nextCursor?: number | null
}

export interface AccessLogFilter {
  studentId?: string
  userId?: string
  action?: AccessAction | ''
  /** epoch ms, включительно */
  from?: number
  /** epoch ms, не включительно */
  to?: number
  cursor?: number | null
  limit?: number
}

/** Query-строка для GET /audit/access (пустые фильтры не передаются). */
export function accessLogQuery(f: AccessLogFilter): string {
  const p = new URLSearchParams()
  if (f.studentId?.trim()) p.set('studentId', f.studentId.trim())
  if (f.userId) p.set('userId', f.userId)
  if (f.action) p.set('action', f.action)
  if (f.from != null) p.set('from', String(f.from))
  if (f.to != null) p.set('to', String(f.to))
  if (f.cursor != null) p.set('cursor', String(f.cursor))
  p.set('limit', String(f.limit ?? 100))
  return p.toString()
}

export const accessLogApi = {
  list: (f: AccessLogFilter) => api<AccessLogPage>(`/audit/access?${accessLogQuery(f)}`),

  /**
   * Сообщить о выгрузке данных учеников (CSV/Excel формируются в браузере).
   * Fire-and-forget: ошибка аудита не должна мешать скачиванию.
   */
  reportExport: (entityType: string, studentIds: string[], entityId?: string) => {
    api('/audit/access/export', {
      method: 'POST',
      body: JSON.stringify({
        entityType,
        entityId,
        studentIds: studentIds.slice(0, 200),
        itemCount: studentIds.length,
      }),
    }).catch(() => undefined)
  },
}
